import { Component, input } from '@angular/core'
import { SdbTag } from '../../_services/AWP/sdbTags.service'
import { sdbTagChipClasses } from './sdb-tag-chip'

/**
 * Badge dei tag SDB. Mostra SEMPRE tutti i tag del frazionario: un sito può
 * averne più di uno e non va troncato.
 */
@Component({
  selector: 'fuseq-sdb-tags',
  standalone: true,
  host: { class: 'inline-block max-w-full align-middle' },
  template: `
    @if (tags().length) {
      <span class="inline-flex max-w-full items-center gap-1"
        [class.flex-wrap]="wrap()"
        [class.flex-nowrap]="!wrap()"
        [class.overflow-x-auto]="!wrap()">
        @for (tag of tags(); track tag.id) {
          <span [class]="chipClasses(tag)" [title]="tag.code">{{ tag.label || tag.code }}</span>
        }
      </span>
    } @else if (!hideEmpty()) {
      <span class="text-xs text-fq-text-muted">—</span>
    }
  `
})
export class SdbTagsComponent {
  readonly tags = input<SdbTag[]>([])
  /** false = una sola riga con scroll orizzontale (utile nelle card mobile). */
  readonly wrap = input(true)
  readonly hideEmpty = input(false)

  chipClasses (tag: SdbTag): string {
    return sdbTagChipClasses(tag)
  }
}
